import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  weeklyHoursRedux: {
    lun: [{ start: "09:00", end: "17:00" }],
    mar: [{ start: "09:00", end: "17:00" }],
    mie: [{ start: "09:00", end: "17:00" }],
    jue: [{ start: "09:00", end: "17:00" }],
    vie: [{ start: "09:00", end: "17:00" }],
    sab: [{ start: "09:00", end: "13:15" }],
    dom: [],
  },
  disabledDaysRedux: [],
  tiempoCitas: localStorage.getItem("tiempoCitas") || "",
  duracionCitas: localStorage.getItem("duracionCitas") || "",
  maximoCitas: localStorage.getItem("maximoCitas") || "",
  maximoTiempoAnticipacion: localStorage.getItem("maximoTiempoAnticipacion") || "",
  citasAgendadas: {},
};

const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    updateWeeklyHoursRedux: (state, action) => {
      state.weeklyHoursRedux = action.payload;
    },
    updateDisabledDaysRedux: (state, action) => {
      state.disabledDaysRedux = action.payload;
    },
    setTiempoCitas: (state, action) => {
      state.tiempoCitas = action.payload;
      localStorage.setItem("tiempoCitas", action.payload);
    },
    setDuracionCitas: (state, action) => {
      state.duracionCitas = action.payload;
      localStorage.setItem("duracionCitas", action.payload);
    },
    setMaximoCitas: (state, action) => {
      state.maximoCitas = action.payload;
      localStorage.setItem("maximoCitas", action.payload);
    },
    setMaximoTiempoAnticipacion: (state, action) => {
      state.maximoTiempoAnticipacion = action.payload;
      localStorage.setItem("maximoTiempoAnticipacion", action.payload);
    },
    agregarCita: (state, action) => {
      const { fecha, hora } = action.payload;
      if (!state.citasAgendadas[fecha]) {
        state.citasAgendadas[fecha] = [];
      }
      state.citasAgendadas[fecha].push(hora);
    },
  },
});

export const {
  updateWeeklyHoursRedux,
  updateDisabledDaysRedux,
  setTiempoCitas,
  setDuracionCitas,
  setMaximoCitas,
  setMaximoTiempoAnticipacion,
  agregarCita, // Nueva acción para agregar citas
} = calendarSlice.actions;

export default calendarSlice.reducer;